type KnownCookieName = 'YII_CSRF_TOKEN';
export const getCookie = (name: KnownCookieName): string =>
    document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';
